import { useQuery } from '@tanstack/react-query';
import config from '../../../../../../../config/config';
import Fetch from '../../../../functions/Fetch';
import { useSelector } from 'react-redux';



const useLocations = () => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });

    const friendly_url = sessionSelector.pdc_project_friendly_url;

    return useQuery({
        queryKey: ['locations'],
        queryFn: async () => {
            return await Fetch.post(config.endpoints.backend + 'portal/getallunits' , {
                filter: {
                    friendly_url: friendly_url
                }
            });
        },
        staleTime: Infinity
    });
};

export default useLocations;
